module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/windows-aef0db2da6c92ce07dde6273900d6c58.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/windows.svg
// module id = +QIq
// module chunks = 24